export const componentName = 'c-Pagination';
